import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { RenderField, RenderSubmitButton } from './common/form';
import { login } from '../actions/AuthActions';
import FacebookLoginButton from './common/auth/FacebookLoginButton';
import * as Validations from './common/form/commonValidations';

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.handleError = this.handleError.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      error: false,
      errorMessage: ''
    };
  }

  onSubmit(values) {
    // console.log('LoginForm~~~~~~~~~~~>values', values);
    const { handleSubmit } = this.props;
    this.setState({ error: false });
    const submitReturn = handleSubmit(values);
    // console.log('~~~~~~~~~~~>submitReturn', submitReturn);
    if (submitReturn.catch) submitReturn.catch(this.handleError);
  }

  handleError(error) {
    this.setState({ error: true, errorMessage: error.detailedMessage });
  }

  render() {
    const { onFacebookSuccess, setAuthState, pristine, submitting } = this.props;
    const { error, errorMessage } = this.state;
    return (
      <div>
        <div className="modal-header">
          <div className="zola-weddings-logo-black-100 center-block" />
          <h3 className="text-center">Log In</h3>
        </div>
        <div className="modal-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                <FacebookLoginButton buttonText="Log In With Facebook" callback={onFacebookSuccess} errorCallback={this.handleError} />
                <div className="h4 text-with-line"><span>or</span></div>
                <form onSubmit={this.onSubmit}>
                  <Field
                    name="email"
                    type="email"
                    label="Email"
                    placeholder="Email"
                    id="login-email"
                    component={RenderField}
                    required
                    validate={[Validations.REQUIRED, Validations.EMAIL]}
                  />
                  <div className="form-group">
                    <Field
                      name="password"
                      id="login-password"
                      label="Password"
                      type="password"
                      component={RenderField}
                      placeholder="Password (8 or more characters)"
                      hideFormGroup
                      required
                      validate={Validations.REQUIRED}
                    />
                    <span className="help-block text-right small"><a role="button" onClick={() => setAuthState('forgot')}>Forgot Password?</a></span>
                  </div>
                  <RenderSubmitButton pristine={pristine} submitting={submitting} valid value="Log In" className="btn-block btn-primary btn btn-lg" />
                </form>
                {error
                  && (
                    <div className="form-message-block text-center text-danger">
                      {errorMessage || 'There was a problem processing your request. Please try again or contact customer support for assistance.'}<br /><br />
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="text-center">Don&#39;t have an account? <a role="button" onClick={() => setAuthState('signup')}>Sign Up Now</a><br /><br /></div>
        </div>
      </div>
    );
  }
}

LoginForm.propTypes = {
  onFacebookSuccess: PropTypes.func.isRequired,
  setAuthState: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: loginFormRequest => dispatch(login(loginFormRequest)).then(ownProps.onLoginSuccess)
});

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'LoginForm'
})(LoginForm));



// WEBPACK FOOTER //
// ./src/components/LoginForm.jsx